import { fb, validators } from '../../../lib/form';

export function getFunctionModel(data) {
  const model = fb.group({
    name: [data.name || '', [validators.Required()], { label: 'Name', type: 'text' }],
    phone: [data.phone || '', [validators.Required()], { label: 'Phone', type: 'text' }],
    email: [data.email || '', [validators.Required(), validators.Email()], { label: 'Email', type: 'email' }],
    event: [data.event || '', [validators.Required()], { label: 'Event', type: 'text'}],
    people: [data.people || '', [validators.Required()], { label: 'How many people', type: 'number'}],
    date: [data.date || '', [validators.Required()], { label: 'Date', type: 'text'}],
    time: [data.time || '', [validators.Required()], { label: 'Time', type: 'text'}],
    enquiry: [data.enquiry || '', [validators.Required()], { label: 'Additional info', type: 'textarea' }],
    //attachments: [data.attachments || '', [], { label: 'Attachments', type: 'file' }]
  }); 
  return model;
}